<template>
  <div class="home">
    <!-- <div class="btn-box">
      <span @click="reset">河南省</span>
      <span v-if="cityinfo" @click="setCity">-{{ cityinfo?.name }}</span>
      <span v-if="countyInfo">-{{ countyInfo?.name }}</span>
    </div> -->
    <!--  <div class="bmap-box" id="bmapChartBox"></div> -->
    <div class="map" id="countymap"></div>
  </div>
</template>
<script setup>
import AMapLoader from "@amap/amap-jsapi-loader";
import { ref, onMounted, nextTick } from "vue";
import * as echarts from "echarts";
import axios from "axios";
import pinyin from "pinyin";
// 点击城市
const cityinfo = ref();
const countyInfo = ref();

onMounted(async () => {
  await nextTick(); // 等待DOM渲染
  /* reset(); */
  let points = [
          [113.841522, 34.95042],
          [113.83803, 34.951197],
          [113.835077, 34.951763],
          [113.83499, 34.950985],
          [113.83277, 34.949466],
          [113.832662, 34.948547],
          [113.834279, 34.948353],
          [113.833589, 34.945667],
          [113.836241, 34.944748],
          [113.836823, 34.947381],
          [113.840638, 34.946639],
          [113.841522, 34.95042]
        ];
  AMapLoader.load({
    key: "e1bbb29a01c134591a9b988edbc12115",
    version: "2.0",
    plugins: ["AMap.Scale"],
  }).then(() => {
    let map = new AMap.Map("countymap", {
      zoom: 15,
      center: points[1],
      layers: [
        new AMap.TileLayer.Satellite(),
        new AMap.TileLayer.RoadNet({
          zIndex: 7,
        }),
      ],
    });
    let Polygon = new AMap.Polygon({
      path: points,
      strokeColor: "#00cc99",
      strokeWeight: 3,
      strokeOpacity: 1,
      fillOpacity: 0.4,
      fillColor: "#1791fc",
      zIndex: 100,
      bubble: true,
    });
    map.add([Polygon]);
  });
});
//初始化河南
const reset = async () => {
  // 请求阿里云地图数据
  const res = await axios.get(
    "https://geo.datav.aliyun.com/areas_v3/bound/geojson?code=410000_full"
  );
  if (res && res.data) {
    drawMap(res.data, "henan");
  }
  cityinfo.value = null;
  countyInfo.value = null;
};
//返回市级
const setCity = async () => {
  let res = await axios.get(
    "https://geo.datav.aliyun.com/areas_v3/bound/geojson?code=" +
      cityinfo.value.code +
      "_full"
  );
  if (res && res.data) {
    init(res.data, cityinfo.value.pinyin);
  }
  countyInfo.value = null;
};
//河南地图
const drawMap = async (json, name) => {
  let img = document.createElement("img");
  img.src = require("@/assets/map-bg.png");
  //地图参数
  const option = {
    series: [
      {
        name: "河南地图",
        type: "map",
        top: "5%",
        left: "5%",
        zlevel: 5, // 地图显示的层级，和z-index 用法一样
        map: "henan", // 这个是上面注册时的名字哦
        label: {
          show: true,
          textStyle: {
            color: "#fff",
          },
        },
        itemStyle: {
          areaColor: {
            image: img, // 背景图
            repeat: "no-repeat", // 是否平铺，可以是 'repeat-x', 'repeat-y', 'no-repeat',
          },
        },
      },
    ],
  };
  //设置地图
  let myChart = echarts.init(document.getElementById("bmapChartBox"));
  echarts.registerMap(name, json);
  myChart.setOption(option);
  //点击地图城市
  myChart.on("click", async (param) => {
    let pinyinText = pinyin(param.name, {
      style: pinyin.STYLE_NORMAL, // 设置拼音样式
    });
    pinyinText = pinyinText.splice(0, pinyinText.length - 1).join("");
    let adcode = "";
    let feature = json.features.find(
      (f) => f.properties && f.properties.name === param.name
    );
    if (feature) {
      adcode = feature.properties.adcode;
      let obj = {
        code: adcode,
        name: param.name,
        pinyin: pinyinText,
      };
      cityinfo.value = JSON.parse(JSON.stringify(obj));
      let res = await axios.get(
        "https://geo.datav.aliyun.com/areas_v3/bound/geojson?code=" +
          adcode +
          "_full"
      );
      myChart.clear();
      init(res.data, pinyinText);
    }
  });
};
//市级地图
const init = (data, name) => {
  const option = {
    series: [
      {
        name: "城市地图",
        type: "map",
        top: "10%",
        zlevel: 5, // 地图显示的层级，和z-index 用法一样
        map: name, // 这个是上面注册时的名字哦
        label: {
          show: true,
          textStyle: {
            color: "#fff",
          },
        },
        itemStyle: {
          normal: {
            areaColor: "#307E51", // 更改地图各个区域的颜色背景
            borderColor: "#93eaf8", // 更改地图各个区域之间边框的颜色
            borderWidth: 0.5, // 边框宽度
            opacity: 0.5, // 透明度
          },
        },
      },
    ],
  };
  let myChart = echarts.init(document.getElementById("bmapChartBox"));
  echarts.registerMap(name, data);
  myChart.setOption(option);
  myChart.on("click", async (param) => {
    let pinyinText = pinyin(param.name, {
      style: pinyin.STYLE_NORMAL, // 设置拼音样式
    });
    pinyinText = pinyinText.splice(0, pinyinText.length - 1).join("");
    let adcode = "";
    let feature = data.features.find(
      (f) => f.properties && f.properties.name === param.name
    );
    if (feature) {
      adcode = feature.properties.adcode;
      let obj = {
        code: adcode,
        name: param.name,
        pinyin: pinyinText,
      };
      countyInfo.value = JSON.parse(JSON.stringify(obj));
      let res = await axios.get(
        "https://geo.datav.aliyun.com/areas_v3/bound/geojson?code=" + adcode
      );
      if (res && res.data) {
        myChart.clear();
        initcounty(res.data, pinyinText);
      }
    }
  });
};
//县级地图
const initcounty = (data, name) => {
  const option = {
    series: [
      {
        name: "城市地图",
        type: "map",
        top: "10%",
        zlevel: 5, // 地图显示的层级，和z-index 用法一样
        map: name, // 这个是上面注册时的名字哦
        label: {
          show: true,
          textStyle: {
            color: "#fff",
          },
        },
        itemStyle: {
          normal: {
            areaColor: "#307E51", // 更改地图各个区域的颜色背景
            borderColor: "#93eaf8", // 更改地图各个区域之间边框的颜色
            borderWidth: 0.5, // 边框宽度
            opacity: 0.5, // 透明度
          },
        },
      },
    ],
  };
  let myChart = echarts.init(document.getElementById("bmapChartBox"));
  echarts.registerMap(name, data);
  myChart.setOption(option);
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  position: relative;
}
.btn-box {
  color: #000;
  font-size: 20px;
  position: absolute;
  top: 100px;
  left: 30%;
  z-index: 10;
  font-weight: bold;
  span {
    cursor: pointer;
  }
}
.bmap-box {
  width: 560px;
  height: 560px;
  margin: auto;
}
.map {
  height: 100%;
  width: 100%;
}
</style>
